// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"efc0e814","4147":"d159a878","9651":"6d084258"}[chunkId] + "-1792686772833.js";
};